import { render } from "./SystemUser.vue?vue&type=template&id=45fe31f1"
import script from "./SystemUser.vue?vue&type=script&lang=js"
export * from "./SystemUser.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__